import { SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const RestrictionsTermsOfUse = () => {
  const { classes } = useTOCStyles();

  return (
    <div>
      <SectionHeader title="Restrictions on use of Materials" />
      <ol start={8}>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`The Contents of this Web Site are provided on an "as-is" basis without warranties of ` +
              `any kind. To the fullest extent permitted by law, SEAB does not warrant and hereby disclaims ` +
              `any warranty that the Contents available through this Web Site or any functions associated ` +
              `therewith will be uninterrupted or error-free, or that defects will be corrected or that this Web ` +
              `Site and the server is and will be free of all viruses and/or other harmful elements.`}
          </Typography>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`SEAB shall also not be liable for any damage or loss of any kind caused as a result ` +
              `(direct or indirect) of the use of the Web Site, including but not limited to any damage ` +
              `or loss suffered as a result of reliance on the Contents contained in or available from the Web Site.`}
          </Typography>
        </li>
      </ol>
    </div>
  );
};

export default RestrictionsTermsOfUse;
